import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [seconds, setSeconds] = useState(3);
  const redirectUrl = 'https://www.cityintyg.se';

  useEffect(() => {
    const countdown = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(countdown);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    const redirectTimer = setTimeout(() => {
      window.location.href = redirectUrl;
    }, 3000);

    return () => {
      clearInterval(countdown);
      clearTimeout(redirectTimer);
    };
  }, []);

  return (
    <div className="container">
      <div className="logos-container">
        <img src="/logo1.png" alt="Logo 1" className="logo logo-old" />
        <div className="arrow">→</div>
        <img src="/logo-city.png" alt="Logo City" className="logo logo-new" />
      </div>
      <div className="message">
        Du har blivit vidarebefordrad från Legehuset Intyg-avdelningen till Cityintyg.
      </div>
      <div className="countdown">
        <span className="spinner"></span>
        Omdirigering sker automatiskt om <span id="seconds">{seconds}</span> sekunder...
      </div>
      <div className="progress-bar">
        <div className="progress-fill"></div>
      </div>
    </div>
  );
}

export default App;
